import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

export const REST_API_CONFIG = new InjectionToken<string>('REST_API_CONFIG');

/**
 * RestAPIサービス.
 */
@Injectable()
export class RestApiService {

  /**
   * コンストラクタ.
   *
   * @param httpClient HttpClient
   */
  constructor(
    private httpClient: HttpClient,
    @Optional() @Inject(REST_API_CONFIG) private apiUrl: string) {
      this.apiUrl = apiUrl || '/api/';
  }

  /**
   * 指定した対象のデータをサーバから取得します.
   *
   * @param target 検索対象の型
   * @param id 検索対象のID
   */
  find<T>(target: string, id?: string): Observable<T> {
    return this.httpClient.get<T>(this.apiUrl + target + '/' + id);
  }

  /**
   * 指定したパラメータに即したデータをサーバから取得します.
   *
   * @param target 検索対象の型
   * @param param 検索対象のID
   */
  search<T>(target: string, param: any): Observable<T> {
    return this.httpClient.get<T>(this.apiUrl + target, {
      params: param
    });
  }

  /**
   * 指定したデータをサーバに登録します.
   *
   * @param target 登録対象の型
   * @param param 登録内容
   */
  register(target: string, param: any): Observable<Object> {
    return this.httpClient.post(this.apiUrl + target, param);
  }

  /**
   * 指定したデータでサーバに登録されているデータを更新します.
   *
   * @param target 更新対象の型
   * @param param 登録内容
   * @param id 更新対象のID
   */
  update(target: string, param: any, id?: string): Observable<Object> {
    return this.httpClient.put(this.apiUrl + target + '/' + id, param);
  }

  /**
   * 指定した対象のデータをサーバから削除します.
   *
   * @param target 削除対象の型
   * @param id 削除対象のID
   */
  delete(target: string, id?: string): Observable<Object> {
    return this.httpClient.delete(this.apiUrl + target + '/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-app/service/rest-api.service.ts